import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { getURLByRouteName } from '../../../utils/routes'
import arrow from '../../../assets/images/svg_icons/arrow.svg'

const Hero = props => {
  const { hero } = props.data
    , [opacity, setOpacity] = useState(0)
  const onLoad = () => setOpacity(1)

  return <div className='home__hero'>
    <div className='home__hero-content transition' style={{ opacity }}>
      <div className='home__hero-title-container'>
        <h1>{hero.title}</h1>
        <h3>{hero.redLabel}</h3>
        <h1>{hero.subtitle}</h1>
        <h3 className='margin-left'>{hero.redLabelSubtitle}</h3>
      </div>
      <div className='home__hero-text-container'>
        <p>{hero.paragraphs}</p>

        <div className='home__hero-button'>
          <Link to={getURLByRouteName('aboutUs')}>{hero.button.text} <img className='arrow-left' src={arrow} alt='flecha' /></Link>
        </div>
      </div>
    </div>
    <div className='white-padding left' />
    <div className='white-padding right' />
    <div className='home__hero-video-background'>
      <video onPlay={onLoad} src={hero.video} autoPlay loop playsInline muted></video>
    </div>
  </div>
}

export default Hero
